import type { TGamesLocale } from '../games.types';

export const games = {
  'red-light-green-light': {
    name: 'წითელი\nმწვანე',
    description:
      'მიაღწიე ფინიშამდე, სანამ მორიგე დგას. მოძრაობა მხოლოდ მწვანეზე — წითელზე გაჩერება გამორიცხვაა. ბოლო დარჩენილი მოთამაშე იგებს.',
    rules: '',
  },
  'chinese-game-go': {
    name: 'GO\n(ჩინური)',
    description:
      'კლასიკური GO თამაში 19×19 დაფაზე. დაიკავე ტერიტორია და აიღე ქვები გამარჯვებისთვის.',
    rules: '',
  },
  'tic-tac-toe': {
    name: '5×5\nტიკ-ტაკ-ტო',
    description:
      'კლასიკის ახალი ვერსია: 5×5 დაფაზე დააკავშირე ოთხი ერთ ხაზში. სწრაფი რაუნდები და მჭიდრო ტაქტიკა.',
    rules:
      'მოთამაშეები სათამაშოდ X-სა და O-ს ცვლავენ 5×5 დაფაზე. პირველი, ვინც ოთხს დააკავშირებს (ჰორიზონტალურად, ვერტიკალურად ან დიაგონალურად), იგებს. თუ დაფა შეივსება გამარჯვების გარეშე — ფრე.',
  },
  'classic-chess': {
    name: 'კლასიკური\nჭადრაკი',
    description:
      'სტანდარტული ჭადრაკი რეიტინგული ფსონებით და დროის კონტროლით. მატით ან დროში გამარჯვებით აიღე ბანკი.',
    rules:
      'სტანდარტული ჭადრაკი. თეთრი იწყებს. 5 წუთი თითო მოთამაშეზე, დამატებითი დროის გარეშე. გამარჯვება მატით ან როცა მოწინააღმდეგეს დრო ამოეწურება.',
  },
  'four-in-a-row': {
    name: 'ოთხი\nრიგში',
    description:
      'ჩამოაგდე დისკები 7×6 დაფაზე და მოწინააღმდეგეს-ზე ადრე დააკავშირე ოთხი რიგში. მარტივი წესები, ღრმა კონტრთამაში.',
    rules:
      'ჩამოაგდე დისკები ზემოდან 7×6 დაფაზე. სათამაშოდ ცვლავ. პირველი, ვინც ოთხს დააკავშირებს (ჰორიზონტალურად, ვერტიკალურად ან დიაგონალურად), იგებს. თუ დაფა შეივსება გამარჯვების გარეშე — ფრე.',
  },
  battleship: {
    name: 'ზღვის ბრძოლა',
    description:
      'კლასიკური ზღვის ბრძოლა: 10×10, ჩაძირე მოწინააღმდეგეს ყველა გემი.',
    rules:
      'კლასიკური ზღვის ბრძოლა: 10×10 დაფა, 10 გემი (1×4, 2×3, 3×2, 4×1). სათამაშოდ ისვენავენ მოწინააღმდეგეს დაფაზე. პირველი, ვინც ყველა გემს ჩაძირავს, იგებს.',
  },
} satisfies TGamesLocale;
